<template>
    <div class="equipment_maintain_container">
        <me-collapes @collapesCb="collapesCb" :treeTitle="'设备树'">
            <!-- <div class="el-card1" style="height: 100%"> -->
            <!-- <div class="leader-title" style="margin-top: 20px">设备树</div> -->
            <div class="tree-wrap">
                <me-tree
                    title="设备树"
                    ref="myTree"
                    :defaultProps="defaultProps"
                    :treeData="treeList"
                    :nodeKey="'tree_id'"
                    :isSingle="true"
                    :showCheckbox="false"
                    :isCheckClick="true"
                    :checkStrictly="true"
                    :treeLoading="treeLoading"
                    :defaultExpandedKeys="defaultExpandedKeys"
                    :treeToolBar="false"
                    @handleTreeNodeClick="handleTreeNodeClick"
                ></me-tree>
            </div>
            <!-- </div> -->
        </me-collapes>
        <div class="right_container" :style="{ width: width }">
            <el-form
                class="leader-style-form leader-form-inline"
                :inline="true"
                style="margin-bottom: 20px"
            >
                <el-row :gutter="10">
                    <!-- <el-col :span="6">
                        <el-form-item label="计划名称">
                            <el-input maxlength="50" v-model="plan_name" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                    </el-col>-->
                    <el-col :span="24" style="text-align:right">
                        <el-button
                            type="primary"
                            @click="doAdd"
                            size="medium"
                            v-show="
                                currentTreeNode && currentTreeNode.is_go == 1
                            "
                        >新增</el-button>
                        <!-- <el-button type="primary" @click="search" size="small">批量删除</el-button> -->
                    </el-col>
                </el-row>
            </el-form>
            <div style="margin-top: 20px;height: 100%">
                <el-scrollbar style="height:100%">
                    <el-table
                        :data="tableData"
                        border
                        @selection-change="handleSelectionChange"
                        class="leader-style-table"
                    >
                        <!-- <el-table-column type="selection" v-if="columnList.length">
                        </el-table-column>-->
                        <el-table-column
                            v-for="(column, index) in columnList"
                            :key="index"
                            :prop="column.colum_id"
                            :label="column.colum_title"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            label="修改"
                            width="180"
                            align="center"
                            v-if="columnList.length"
                        >
                            <template slot-scope="scope">
                                <el-button
                                    @click="detailsItemShow(scope.row)"
                                    type="text"
                                    class="button-custom"
                                >
                                    <i class="iconfont iconsearch"></i>
                                    <span class="inner-text">查看</span>
                                </el-button>
                                <el-button
                                    @click="changeItemShow(scope.row)"
                                    type="text"
                                    class="button-modify"
                                >
                                    <i class="iconfont iconeditor"></i>
                                    <span class="inner-text">修改</span>
                                </el-button>
                                <el-button
                                    @click="deleteItemShow(scope.row)"
                                    type="text"
                                    class="button-delete"
                                >
                                    <i class="iconfont iconashbin"></i>
                                    <span class="inner-text">删除</span>
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-scrollbar>

                <!-- <Pagination
                    class="leader-style-pagination"
                    :paginationData="paginationData"
                    @paginationDataNew="paginationDataNew"
                    v-if="this.paginationData.totalNum"
                ></Pagination>-->
            </div>
        </div>
        <el-dialog
            class="leader-dialog"
            width="1000px"
            :title="add_title"
            :visible.sync="addshow"
            :close-on-click-modal="false"
            destroy-on-close="true"
        >
            <EquipmentAddA
                v-if="currentTreeNode && currentTreeNode.tree_level != '40'"
                :addColumn="addColumn"
                @changeTitle="changeTitle"
                :currentTreeNode="currentTreeNode"
                @emitDataChange="emitDataChange"
                @closeDialog="closeDialog"
            ></EquipmentAddA>
            <EquipmentAddB
                v-else
                :from="0"
                :shebeiChecklist="shebeiChecklist"
                :currentTreeNode="currentTreeNode"
                @closeDialog="closeDialog"
            ></EquipmentAddB>
        </el-dialog>
        <el-dialog
            class="leader-dialog"
            width="1000px"
            title="修改设备信息"
            :visible.sync="editshow"
            :close-on-click-modal="false"
            destroy-on-close="true"
        >
            <EquipmentEdit
                :editColumn="editColumn"
                :currentData="currentData"
                :currentTreeNode="currentTreeNode"
                @emitDataChange="emitDataChange"
                @closeDialog="closeDialog"
            ></EquipmentEdit>
        </el-dialog>
        <el-dialog
            class="leader-dialog"
            title="查看"
            :visible.sync="detailsShow"
            :close-on-click-modal="false"
        >
            <el-scrollbar class="equipment_scroll">
                <div v-for="(value, key) in detailTableData" :key="key" class="group">
                    <div class="group_title">{{ key }}</div>
                    <mailTable :tableData="value" :tableStyle="{ width: '100%' }"></mailTable>
                </div>
            </el-scrollbar>
        </el-dialog>
    </div>
</template>
<script>
import * as api from '../api/index';
import Tree from '@/comon/components/tree.vue';
import EquipmentAddA from './components/equipment_add_a.vue';
import EquipmentAddB from './components/equipment_add_b.vue';
import EquipmentEdit from './components/equipment_edit.vue';
import Collapes from '@/comon/components/collapse-block.vue';
import mailTable from '@/comon/components/TableComponent.vue';
export default {
    components: {
        'me-tree': Tree,
        'me-collapes': Collapes,
        EquipmentAddA: EquipmentAddA,
        EquipmentAddB: EquipmentAddB,
        EquipmentEdit: EquipmentEdit,
        mailTable: mailTable,
    },
    data() {
        return {
            treeList: [],
            treeLoading: false,
            tree_id: '1',
            defaultProps: {
                children: 'childList',
                label: 'tree_name',
            },
            width: 'calc(100% - 280px)',
            columnList: [],
            tableData: [],
            paginationData: [],
            multipleSelection: [], //被选中的复选框
            addshow: false, //新增弹框
            editshow: false, //修改弹框
            detailsShow: false, //查看弹框
            detailTableData: {},
            currentTreeNode: null, // 当前选中的树
            add_title: '',
            addColumn: [],
            editColumn: [],
            currentData: {}, //当前要修改的行
            shebeiChecklist: [],
            defaultExpandedKeys: ['1'],
        };
    },
    created() {
        this.getPointTree();
    },
    methods: {
        getPointTree() {
            this.treeLoading = true;
            api.getUnitDocTreeList().then((res) => {
                if (res) {
                    this.treeList = res.bus_json;

                    if (this.currentTreeNode && this.currentTreeNode.tree_id) {
                        this.$nextTick(() => {
                            this.$refs.myTree.$refs.tree.setCurrentNode(
                                this.currentTreeNode
                            );
                        });
                    } else {
                        if (this.treeList.length > 0) {
                            this.$nextTick(() => {
                                this.$refs.myTree.$refs.tree.setCurrentNode(
                                    this.treeList[0]
                                );
                                this.handleTreeNodeClick(this.treeList[0]);
                            });
                        }

                    }
                }
                this.treeLoading = false;
            });
        },
        handleTreeNodeClick(select) {
            this.currentTreeNode = select;
            this.defaultExpandedKeys = [
                ...this.defaultExpandedKeys,
                select.tree_id,
            ];
            api.getTitleDocColumList({ tree_level: select.tree_level }).then(
                (res) => {
                    if (res) {
                        this.columnList = res.bus_json;
                        api.getDocColumList({
                            p_tree_id: select.tree_id,
                            tree_level: select.tree_level,
                        }).then((_res) => {
                            if (_res) {
                                let tableData = [];
                                let tableItem;
                                _res.bus_json.forEach((row, index) => {
                                    tableItem = {};
                                    row.forEach((item, index) => {
                                        tableItem[item.colum_id] = item.name;
                                        tableItem.tree_id = item.tree_id;
                                        tableItem.tree_type_id =
                                            item.tree_type_id;
                                    });
                                    tableData.push(tableItem);
                                });
                                this.tableData = tableData;
                                // this.paginationData.totalNum = res.bus_json.totalNum;
                                // this.paginationData.pageNum = res.bus_json.pageNum;
                                // this.paginationData.pageSize = res.bus_json.pageSize;
                                // this.paginationData.totalPage = res.bus_json.totalPage;
                            }
                        });
                    }
                }
            );
        },
        collapesCb(collapes) {
            this.width = collapes ? 'calc(100% - 280px)' : 'calc(100% - 61px)';
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        doAdd(formName) {
            if (!this.currentTreeNode) {
                this.$message({
                    type: 'info',
                    message: '请选择一个树节点!',
                });
                return;
            }
            this.addshow = true;
            if (this.currentTreeNode.tree_level == '40') {
                this.add_title = '新增子设备';
                api.getTreeTypeRelation({
                    tree_type_id: this.currentTreeNode.tree_type_id,
                }).then((res) => {
                    this.shebeiChecklist = res.bus_json;
                });
            } else {
                this.add_title = '设备新增:维护基础信息';
                api.getAddColumId({
                    tree_level: this.currentTreeNode.tree_level,
                }).then((res) => {
                    // res.bus_json.forEach((item, index)=>{
                    //     if(item.colum_title=='设备型号') item.need_colum_id = 'pdbyq_000003'
                    // })
                    this.addColumn = res.bus_json;
                });
            }
        },
        changeTitle(hasNext) {
            if (hasNext) this.add_title = '设备新增-第1/2步:维护基础信息';
            else this.add_title = '设备新增:维护基础信息';
        },
        deleteItemShow(row) {
            this.$confirm('确认删除档案？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then((_) => {
                api.delTree({
                    tree_id: row.tree_id,
                }).then((res) => {
                    this.reloadPage();
                });
            });
        },
        changeItemShow(row) {
            api.getUpdateDocTreeColum({
                tree_type_id: row.tree_type_id,
                tree_id: row.tree_id,
                tree_level: this.currentTreeNode.tree_level,
                p_tree_id: this.currentTreeNode.tree_id,
            }).then((res) => {
                this.editColumn = res.bus_json;
                this.currentData = row;
            });
            this.editshow = true;
        },
        detailsItemShow(row) {
            this.detailTableData = {};
            api.getDocTreeColum({
                tree_type_id: row.tree_type_id,
                tree_id: row.tree_id,
            }).then((res) => {
                if (res) {
                    let tableItemList = [];
                    let tableItem = {};
                    for (let key in res.bus_json) {
                        tableItemList = [];
                        res.bus_json[key].forEach((item, index) => {
                            tableItem = {};
                            tableItem.key = item.colum_title;
                            tableItem.value = item.colum_value;
                            tableItemList.push(tableItem);
                        });
                        this.detailTableData[key] = tableItemList;
                    }
                    this.detailsShow = true;
                    //console.log(this.detailTableData);
                }
            });
        },
        emitDataChange(data) {
            this.add_title = data.add_title;
        },
        closeDialog(refresh) {
            this.addshow = false;
            this.editshow = false;
            if (refresh) {
                this.reloadPage();
            }
        },
        reloadPage() {
            this.getPointTree();
            this.handleTreeNodeClick(this.currentTreeNode);
            // setCurrentNode
        },
    },
};
</script>
<style lang="scss">
@import "../../../../assets/css/equipment.css";
.equipment_maintain_container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    .tree-wrap {
        height: 100%;
        padding-top: 10px;
        // box-sizing: border-box;
        width: 280px;
        // overflow: hidden;
        // box-sizing: border-box;
    }
    .group {
        //border:2px solid #1e4283;
        /*border:2px solid #1e40a3;*/
        padding: 0 15px;
        margin: 10px 0 20px 0;
        .group_title {
            height: 20px;
            vertical-align: middle;
            z-index: 0;
            // @include font_color;
            color: #fff;
            font-size: 15px;
            margin: -10px 0 10px 20px;
        }
        .mailTable {
            margin-left: 0 !important;
        }
    }
}
.right_container {
    box-sizing: border-box;
    // margin: 4px 10px 10px 0;
    max-height: 700px;
}
</style>
